import React, { useEffect, useState } from 'react';
import { demoRecipeList } from '../../Utils/demoData';
// import PropTypes from 'prop-types'
import style from './style.module.scss';
import RecipeCell from '../RecipeCell';
import NoImage from '../NoImage';
import { connect } from 'react-redux';

const RecipeList = (props) => {

    return (
        <div className={style.recipeWrapper}>
            <div className={style.recipeCell}>
                {
                    props.recipes.map((item, key) => <div className={style.item}> <RecipeCell key={key} index={key} data={item} /></div>)
                }
            </div>
        </div>
    )
}

export default connect((state) => {
    return {
        recipes: state.recipes
    }
})(RecipeList)
